export default "__VITE_ASSET__a9c6e1eb__"